import { getClientDefaultValues } from "@/pages/clients/client/CreateClient";
import {
  ClientSettingsQuery,
  ProposalNavigationPositionType,
  Scope,
} from "../../generated/apollo";
import { useClientSettings } from "../general/clientSettings";

export function initClientSettings(data: ClientSettingsQuery | undefined) {
  const {
    entityNamePlural,
    entityNameSingular,
    insightPlaceholderSingular,
    insightPlaceholderPlural,
  } = getClientDefaultValues();
  const clientConfig = {
    entityName: {
      plural: entityNamePlural,
      singular: entityNameSingular,
    },
    insightPlaceholder: {
      singular: insightPlaceholderSingular,
      plural: insightPlaceholderPlural,
    },
    proposalNavigationPosition: ProposalNavigationPositionType.Vertical,
    permissions: {},
    isLoading: false,
  };
  if (!data) {
    useClientSettings.setState(clientConfig);
    return;
  }

  clientConfig.entityName.singular = data.currentClient.entityNameSingular;
  clientConfig.entityName.plural = data.currentClient.entityNamePlural;
  clientConfig.insightPlaceholder.singular =
    data.currentClient.insightPlaceholderSingular;
  clientConfig.insightPlaceholder.plural =
    data.currentClient.insightPlaceholderPlural;
  clientConfig.proposalNavigationPosition =
    data.currentClient.proposalNavigationPosition;
  clientConfig.permissions = data.currentClient.clientPermissions.reduce<
    Record<string, Scope[]>
  >((acc, { role, scope }) => {
    return { ...acc, [role]: [...(acc[role] ?? []), scope] };
  }, {});

  useClientSettings.setState(clientConfig);
}
